module.exports = __webpack_public_path__ + "img/tk.93027946.png";